<template>
    <div>
        <div class="my-3 flex justify-between flex-wrap md:flex-nowrap px-2">
            <InputText 
                type="text"
                v-model="sharingUrl"
                disabled
                class="w-full md:mr-3"
            />
            <Button 
                label="Copiar"
                class="w-full mt-1 md:mt-0 md:w-1/6 no-bg-button"
                @click="copyToClipboard"
            />
        </div>
        <div :class="isScreenSmall() ? props.classOnSmall : props.class">
            <template v-for="(socialMedia, index) in socialMedias" :key="index">
                <ShareNetwork 
                    :network="socialMedia.name" 
                    :url="sharerValues.link" 
                    :title="translate(sharerValues.title)" 
                    :description="sharerValues.description"
                    :quote="sharerValues.title"
                    :hashtags="sharerValues.hashtag"
                    v-slot="{ share }"
                > 
                    <Button 
                        @click="share" 
                        class="w-auto mb-4 text-white border rounded-full md:rounded-none" 
                        :style="{ 'background-color' : socialMedia.bgColor, 'border-color': socialMedia.bgColor }"
                    >
                        <i :class="socialMedia.icon" style="font-size: 1.3rem;">{{ socialMedia.icon == '' ? ucfirst(socialMedia.name) : '' }}</i>
                    </Button>
                </ShareNetwork>
            </template>
        </div>
    </div> 
</template>
  
<script setup>
import { env } from "@/composables/config";
import { translate } from "@/composables/translate";
import { ShareNetwork } from "vue3-social-sharing";
import { ucfirst } from "@/composables/textUtils";
import { onMounted, ref, watch, defineProps } from "vue";
import Button from "primevue/button";
import InputText from 'primevue/inputtext';
import { showToast } from "@/composables/toast";
import { useToast } from 'primevue/usetoast';

const toast = useToast();
let props = defineProps({
    link: {
        type: String,
        required: true,
        default: env('APP_BASE_URL')
    },
    title: {
        type: String,
        required: true,
        default: translate('check out this', 'ucfirst')
    },
    description: {
        type: String,
        required: false,
        default: ''
    },
    hashtag: {
        type: String,
        required: false,
        default: ''
    },
    class: {
        type: String,
        required: false,
        default: 'flex flex-wrap px-2 gap-3'
    },
    classOnSmall: {
        type: String,
        required: false,
        default: 'flex flex-wrap flex-col gap-3'
    },
    socialMediasSharing: {
        type: Array,
        required: false,
        default: null
    }
})

const socialMedias = ref([
    {name: 'facebook',  icon: 'pi pi-facebook',  bgColor: '#3a5997'},
    {name: 'twitter',   icon: 'pi pi-twitter',   bgColor: '#1e1c1d'},
    {name: 'linkedin',  icon: 'pi pi-linkedin',  bgColor: '#007bb6'},
    {name: 'whatsapp',  icon: 'pi pi-whatsapp',  bgColor: '#43d853'},
    {name: 'email',     icon: 'pi pi-envelope',  bgColor: 'rgb(145, 145, 145)'},
    {name: 'telegram',  icon: 'pi pi-telegram',  bgColor: '#0087cc'}
]);

let sharerValues = ref({
    link: props.link,
    title: props.title,
    description: props.description
})
const windowWidth = ref(window.innerWidth);
const breakPoint = 500;
const sharingUrl = ref('');
onMounted(() => {
  checkAllowedSocialMedias();

  handleResize();
  window.addEventListener('resize', handleResize);
  isScreenSmall();
  sharerValues.value.link = props.link;
  sharerValues.value.title = props.title;
  sharerValues.value.description = props.description;
  sharingUrl.value = props.link;
});

watch(() => props.link, (newLink) => {
    sharerValues.value.link = newLink;
},
  { deep: true }
);
watch(() => props.title, (newTitle) => {
    sharerValues.value.title = newTitle;
},
  { deep: true }
);
watch(() => props.description, (newDescription) => {
    sharerValues.value.description = newDescription;
},
  { deep: true }
);
watch(() => props.hashtag, (newHastag) => {
    sharerValues.value.hashtag = newHastag;
},
  { deep: true }
);

function checkAllowedSocialMedias() {
    if (!props.socialMediasSharing || !Array.isArray(props.socialMediasSharing) || props.socialMediasSharing.length < 1)
        return;
    let allowedSocialMedias = [];
    for (let key of Object.keys(socialMedias.value)) {
        if (props.socialMediasSharing.includes(socialMedias.value[key].name))
            allowedSocialMedias.push(socialMedias.value[key]);
    }
    socialMedias.value = allowedSocialMedias;
}

function handleResize(){
  windowWidth.value = window.innerWidth;
}

function isScreenSmall(){
  return windowWidth.value > breakPoint ? false : true;
}

async function copyToClipboard() {
    try {
        await navigator.clipboard.writeText( sharingUrl.value);
        showToast(toast, translate('link copied', 'ucfirst'), 'info');
    } catch (err) {
        showToast(toast, translate('link not copied', 'ucfirst'), 'error');
        throw err;
    }
}

</script>